import React from "react";

const HelpSection = ({ help }) => {
  return (
    <div className="mt-4 p-3 border rounded">
      <h6>NEED HELP?</h6>
      <p>{help.workingHours}</p>
      <ul className="list-unstyled">
        <li>💬 {help.whatsappOrder}</li>
        <li>📞 {help.contact}</li>
        <li>📧 {help.email}</li>
      </ul>
    </div>
  );
};

export default HelpSection;
